
import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '#about' },
    { name: 'Consumer Debt', href: '#consumer-debt' },
    { name: 'Business Debt', href: '#business-debt' },
    { name: 'How It Works', href: '#how-it-works' },
  ];

  const services = [
    { name: 'Credit Card Debt Relief', href: '#consumer-debt' },
    { name: 'Personal Loan Settlement', href: '#consumer-debt' },
    { name: 'Merchant Cash Advance Relief', href: '#business-debt' },
    { name: 'Business Loan Settlement', href: '#business-debt' },
    { name: 'Free Consultation', href: '#contact' },
  ];

  return (
    <footer className="bg-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <img 
              src="https://static.readdy.ai/image/a9d6aff03562300b57162884cb61551b/452a0b34ca5601d37f92054b15f576b4.png" 
              alt="Brite Solutions Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Professional debt settlement solutions for consumers and businesses since 2008. 
              Licensed professionals helping Americans achieve financial freedom.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">QUICK LINKS</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">SERVICES</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.name}>
                  <a 
                    href={service.href}
                    className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">CONTACT</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="fas fa-phone text-orange-400"></i>
                <a 
                  href="tel:1-800-DEBT-FREE" 
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                >
                  1-800-DEBT-FREE
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="fas fa-envelope text-orange-400"></i>
                <a 
                  href="mailto:info@britesolutions.com" 
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                >
                  info@britesolutions.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <i className="fas fa-map-marker-alt text-orange-400 mt-1"></i>
                <span className="text-gray-300 text-sm">
                  Licensed Nationwide<br />
                  Serving All 50 States
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-teal-700">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="text-6xl font-bold text-teal-600 opacity-30 select-none mb-4 lg:mb-0">
              BRITE
            </div>
            <div className="flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 lg:space-x-6 text-sm text-gray-400">
              <span>&copy; 2024 Brite Solutions. All rights reserved.</span>
              <div className="flex space-x-4">
                <a href="#" className="hover:text-white transition-colors duration-300">Privacy Policy</a>
                <a href="#" className="hover:text-white transition-colors duration-300">Terms of Service</a>
                <a href="https://readdy.ai/?ref=logo" className="hover:text-white transition-colors duration-300">Website Builder</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
